import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Icon from "@material-ui/core/Icon";
// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Fab from "@material-ui/core/Fab";
import Button from "components/CustomButtons/Button.jsx";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import customTabsStyle from "assets/jss/material-kit-react/components/customTabsStyle.jsx";
import Slide from "@material-ui/core/Slide";

import PowerSettingsNew from "@material-ui/icons/PowerSettingsNew";
function Transition(props) {
  return <Slide direction="up" {...props} />;
}
class CustomTabs extends React.Component {
  state = {
    value: 0,
    openDialog: false
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleOut = () => {
    this.setState({
      openDialog: true
    });
  };
  handleLogout = () => {
    this.props.handleLogout();
  };
  handleClose = () => {
    this.setState({
      openDialog: false
    });
  };
  render() {
    const {
      classes,
      headerColor,
      plainTabs,
      tabs,
      title,
      rtlActive
    } = this.props;
    const cardTitle = classNames({
      [classes.cardTitle]: true,
      [classes.cardTitleRTL]: rtlActive
    });
    return (
      <Card plain={plainTabs}>
        <Dialog
          open={this.state.openDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          onKeyPress={this.handleKeyPress}
        >
          <DialogTitle id="alert-dialog-slide-title">{"알림"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              로그아웃 하시겠습니까 ?
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleClose} color="cancel">
              취소
            </Button>
            <Button onClick={this.handleLogout} color="submit">
              확인
            </Button>
          </DialogActions>
        </Dialog>
        <CardHeader
          color={headerColor}
          plain={plainTabs}
          className={classes.cardHeader}
        >
          {title !== undefined ? (
            <div className={cardTitle}>{title}</div>
          ) : null}
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            classes={{
              root: classes.tabsRoot,
              indicator: classes.displayNone
            }}
          >
            {tabs.map((prop, key) => {
              var icon = {};
              if (prop.tabIcon) {
                icon = {
                  icon:
                    typeof prop.tabIcon === "string" ? (
                      <Icon>{prop.tabIcon}</Icon>
                    ) : (
                      <prop.tabIcon />
                    )
                };
              }
              return (
                <Tab
                  classes={{
                    root: classes.tabRootButton,
                    labelContainer: classes.tabLabelContainer,
                    label: classes.tabLabel,
                    selected: classes.tabSelected,
                    wrapper: classes.tabWrapper
                  }}
                  key={key}
                  label={prop.tabName}
                  {...icon}
                />
              );
            })}
          </Tabs>

          <div style={{ position: "absolute", right: 30 }}>
            <a
              className={classes.btnPdf}
              // style={{ marginRight: "30px" }}
              href="/notice"
            >
              공지사항
            </a>
            <a
              className={classes.btnPdf}
              // style={{ marginRight: "30px" }}
              href="/pdf"
            >
              PDF VIEWER
            </a>
            <Fab
              size="small"
              label="로그아웃"
              alt="로그아웃"
              className={classes.fabCusom}
              onClick={() => this.handleOut()}
            >
              <PowerSettingsNew />
            </Fab>
          </div>
        </CardHeader>
        <CardBody>
          {tabs.map((prop, key) => {
            if (key === this.state.value) {
              return <div key={key}>{prop.tabContent}</div>;
            }
            return null;
          })}
        </CardBody>
      </Card>
    );
  }
}

CustomTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  headerColor: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose"
  ]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string.isRequired,
      tabIcon: PropTypes.func,
      tabContent: PropTypes.node.isRequired
    })
  ),
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool
};

export default withStyles(customTabsStyle)(CustomTabs);
